import React__default from 'react';
import 'copy-to-clipboard';
import '../../Hooks/useDateTimeFormat/useDateTimeFormat.js';
import 'use-debounce';
import useFromNow from '../../Hooks/useFromNow/useFromNow.js';
import 'crypto-js';
import '../../../node_modules/@faker-js/faker/dist/esm/chunk-3LPAMF3R.js';
import '../../../node_modules/@faker-js/faker/dist/esm/chunk-LSZKOVGW.js';
import '../../../node_modules/@faker-js/faker/dist/esm/chunk-GTEBSQTL.js';
import 'react-router-dom';
import '../../Providers/LanguageProvider/LanguageProvider.js';
import '@azure/msal-react';
import ChatFeedback from '../ChatFeedback/ChatFeedback.js';

const ChatElement = ({ placement = 'left', chatBubble = false, borderRadius = 10, chatBubbleMargin = 100, chatBubblePadding = 20, showFeedback = true, showFeedbackTooltips = false, showTime = true, timestamp = Date.now(), type = 'question', textSize = 'medium', showFeedbackReasons = true, ...props }) => {
    let templateColumns = undefined;
    let chatBubbleGap = 0;
    if (props.avatar)
        chatBubbleGap = 10;
    if (props.avatar && placement === 'left')
        templateColumns = '40px 1fr';
    if (props.avatar && placement === 'right')
        templateColumns = '1fr 40px';
    const chatTS = useFromNow(timestamp);
    function bgcolor(chatbubble, type) {
        const questionBG = '#FAFAFA';
        const answerBG = '#f7f2fa';
        const errorBG = '#FF0000';
        if (chatBubble) {
            if (type === 'question')
                return questionBG;
            if (type === 'answer')
                return answerBG;
            if (type === 'error')
                return errorBG;
        }
        return undefined;
    }
    const fontsize = () => {
        if (textSize === 'small')
            return 14;
        if (textSize === 'large')
            return 16;
        return 15;
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { style: {
                display: 'grid',
                gridTemplateColumns: templateColumns,
                gap: chatBubbleGap,
            } },
            props.avatar && placement === 'left' ? (React__default.createElement("div", null, props.avatar)) : null,
            React__default.createElement("div", { style: {
                    marginLeft: placement === 'right' && chatBubble ? chatBubbleMargin : 0,
                    marginRight: placement === 'left' && chatBubble ? chatBubbleMargin : 0,
                } },
                React__default.createElement("div", { style: {
                        fontFamily: 'Siemens',
                        fontSize: fontsize(),
                        color: !chatBubble && type === 'question' ? '#666666' : '#000000',
                        padding: chatBubble ? chatBubblePadding : 0,
                        borderTopLeftRadius: placement === 'left' && chatBubble ? 0 : borderRadius,
                        borderTopRightRadius: placement === 'right' && chatBubble ? 0 : borderRadius,
                        borderBottomLeftRadius: borderRadius,
                        borderBottomRightRadius: borderRadius,
                        backgroundColor: bgcolor(chatBubble, type),
                        whiteSpace: 'pre-wrap',
                    } }, props.children),
                showTime && timestamp ? (React__default.createElement("div", { style: {
                        color: '#CCCCCC',
                        fontSize: 13,
                        textAlign: placement,
                    } }, chatTS)) : null,
                showFeedback ? (React__default.createElement(ChatFeedback, { showTooltip: showFeedbackTooltips, showReasons: showFeedbackReasons, placement: placement })) : null),
            props.avatar && placement === 'right' ? (React__default.createElement("div", null, props.avatar)) : null)));
};

export { ChatElement as default };
//# sourceMappingURL=ChatElement.js.map
